import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { getStoredAuthToken } from '../../auth/auth-token';

@Injectable({ providedIn: 'root' })
export class UserFavouriteService {
  private readonly platformId = inject(PLATFORM_ID);

  constructor(private http: HttpClient) { }

  getUserFavourite(): Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/favourite/user`, {
      headers: this.authHeaders(),
    });
  }

  addToFavourite(data: any): Observable<any> {
    return this.http.post(`${environment.backendUrl}/api/favourite/add`, data, {
      headers: this.authHeaders(),
    });
  }

  removeFromFavourite(id: string) {
    const params = new HttpParams().set('id', id);

    return this.http.delete(`${environment.backendUrl}/api/favourite/remove`, {
      headers: this.authHeaders(),
      params,
    });
  }

  private authHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.getAuthToken() ?? ''}`,
    });
  }

  private getAuthToken(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    return getStoredAuthToken();
  }
}
